import { theme } from '@superhi/design'
import styled from 'styled-components'

const SPACING = 32

export const Desktop = styled.div`
  display: none;

  @media ${theme.breakpoints.large} {
    display: block;
  }
`

export const Mobile = styled.div`
  display: block;

  @media ${theme.breakpoints.large} {
    display: none;
  }
`

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  margin: -${SPACING / 2}px;
`

export const Cell1 = styled.div`
  margin: ${SPACING / 2}px;
  flex-shrink: 0;
  width: 33.3333%;

  > * {
    height: 100%;
  }
`

export const Cell2 = styled.div`
  margin: 0;
  flex-grow: 1;

  display: flex;
  flex-wrap: wrap;
`

export const Cell3 = styled.div`
  margin: ${SPACING / 2}px;
  width: calc(50% - ${SPACING}px);

  > * {
    height: 100%;
  }
`
